module.exports = __webpack_public_path__ + "static/media/possible5.aab44578.webp";